// ARTWORK COMPONENT, SHOWS DETAILED DATA ABOUT CERTAIN PAINTING (CLICKED ON THE HOMEPAGE)

import React, { useContext } from "react";
import MetaTags from "react-meta-tags";
import { Link } from "react-router-dom";
import { LanguageContext } from "./../language-context";
import * as variables from "./helper/Variables";
import styled, { css } from "styled-components";
import { PageTitle } from "./helper/PageTitle";
import { Scroll } from "./helper/Scroll";
import { pl } from "./../data/pl";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { ImageGallery } from "./ImageGallery";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";

const margin = css`
  margin: 0.25rem 0;
`;

const ImageContainer = styled.div`
  ${variables.Flex};
  flex-direction: column;
  ${variables.DimensionsView};
  padding: 0 2rem;
  background-color: ${variables.BACKGROUND_GRAY};

  @media (max-width: 1000px) {
    height: auto;
    padding: 0 2rem 4rem;
  }
`;

const ArtworkDataContainer = styled.div`
  display: flex;
  align-items: start;
  justify-content: center;
  width: 100vw;
  min-height: 100vh;
  background-color: ${variables.BACKGROUND_GRAY};

  @media (max-width: 1000px) {
    padding-bottom: 6rem;
  }
`;

const ArtworkData = styled.div`
  ${variables.Flex};
  flex-direction: column;
  width: 80%;
  z-index: 1;
`;

const ArtworkTitle = styled.div`
  ${variables.Flex};
  ${margin};
  text-align: center;
  font-size: ${variables.BIG_TITLE_FONT};
  font-weight: bold;

  @media (max-width: 500px), (max-width: 900px) and (orientation: landscape) {
    font-size: ${variables.TITLE_FONT};
  }
`;

const ArtworkAvailability = styled.div`
  ${variables.Flex};
  font-size: ${variables.TITLE_FONT};
  ${margin};

  @media (max-width: 500px), (max-width: 900px) and (orientation: landscape) {
    font-size: ${variables.REGULAR_FONT};
  }
`;

const ArtworkDescription = styled.div`
  ${variables.Flex};
  ${margin};
  white-space: pre-wrap;
  width: 60vw;
  margin-top: 1rem;

  @media (max-width: 500px), (max-width: 900px) and (orientation: landscape) {
    font-size: ${variables.MOBILE_FONT};
    width: 100%;
  }
`;

const ArtworkTitleAndCycle = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 2rem;
  opacity: 0;
  animation: ${variables.ChangeOpacity} 0.5s 2s linear forwards;

  @media (max-width: 500px), (max-width: 900px) and (orientation: landscape) {
    font-size: ${variables.MOBILE_FONT};
  }
`;

const ArtworkDimensions = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  padding: 2rem;
  opacity: 0;
  animation: ${variables.ChangeOpacity} 0.5s 2s linear forwards;

  @media (max-width: 500px), (max-width: 900px) and (orientation: landscape) {
    font-size: ${variables.MOBILE_FONT};
  }
`;

const BackButton = styled(Link)`
  ${variables.Flex};
  width: auto;
  height: auto;
  //position: relative;
  //bottom: 3.5rem;
  //height: auto;
  //padding: 0 10.4vw;
  text-decoration: none;
  color: ${variables.DARK};
  background-color: ${variables.BACKGROUND_GRAY};
  font-size: ${variables.REGULAR_FONT};
  font-weight: 600;
  overflow: visible;
`;

const ArrowsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Artwork = () => {
  const artworkId = window.location.href.slice(-4); //Takes ID from dynamically created URL to show correct data about painting

  const redirectAndReload = () => {
    // eslint-disable-next-line
    window.location.replace(`http://www.michalkrol.com/#/404`),
      window.location.reload();
  };

  pl.artworks[artworkId] === undefined && redirectAndReload(); //Checks if artwork exist - if not, shows 404 page

  const usedLanguage = useContext(LanguageContext);

  const {
    artworkTitle,
    artworkCreationDate,
    artworkCycle,
    artworkDimensionWidth,
    artworkDimensionHeight,
    artworkImages,
  } = pl.artworks[window.location.href.slice(-4)]; //pl because this data is the same no matter the language

  const { backToCyclesPage } = usedLanguage.language.menu;

  const { artworkAvailability, artworkDescription } =
    usedLanguage.language.artworks[window.location.href.slice(-4)]; //usedLanguage.language because this data is unique depending on language

  const images = [];

  Object.keys(artworkImages).map((artwork) => {
    images.push(`./../images/artworks/${artworkId}/${artwork}.jpg`);
  });

  Scroll();

  const cycleImages = [];
  let nextCycleImage = "";
  let prevCycleImage = "";

  Object.keys(pl.artworks).map((artwork) => {
    if (pl.artworks[artwork].artworkCycle == artworkCycle) {
      cycleImages.unshift(artwork);
    }
  });

  function findNeighbors(artworkId) {
    const index = cycleImages.indexOf(artworkId);

    if (index === -1) {
      prevCycleImage = null;
      nextCycleImage = null;
      return;
    }

    prevCycleImage = index > 0 ? cycleImages[index - 1] : null;
    nextCycleImage =
      index < cycleImages.length - 1 ? cycleImages[index + 1] : null;
  }

  findNeighbors(artworkId);

  return (
    <main style={{ backgroundColor: variables.BACKGROUND_GRAY }}>
      <MetaTags>
        <title>{artworkTitle} | Structuralist</title>
        <meta name="description" content={artworkDescription} />
        <meta
          name="keywords"
          content={`"Structuralist", "Michał Król", ${artworkTitle}, ${artworkCycle}`}
        />
      </MetaTags>
      <PageTitle
        text={artworkTitle}
        backgroundColor={variables.BACKGROUND_GRAY} //Styled Components props
      />
      <ImageContainer>
        <ImageGallery key={artworkId} imageSources={images} />
        <ArrowsContainer>
          {nextCycleImage && (
            <BackButton to={"/artworks/" + nextCycleImage}>
              <RiArrowLeftSLine
                style={{
                  fontSize: "3rem",
                }}
              />
            </BackButton>
          )}
          {prevCycleImage && (
            <BackButton to={"/artworks/" + prevCycleImage}>
              <RiArrowRightSLine
                style={{
                  fontSize: "3rem",
                }}
              />
            </BackButton>
          )}
        </ArrowsContainer>
      </ImageContainer>
      <ArtworkDataContainer>
        <ArtworkData>
          <ArtworkTitle>{artworkTitle}</ArtworkTitle>
          <ArtworkAvailability>
            {artworkCreationDate} / {artworkAvailability}
          </ArtworkAvailability>
          <ArtworkDescription>{artworkDescription}</ArtworkDescription>
        </ArtworkData>
        <ArtworkTitleAndCycle>
          <p>{artworkTitle}</p>
          <p>{artworkCycle}</p>
        </ArtworkTitleAndCycle>
        <ArtworkDimensions>
          <p>{artworkDimensionWidth}</p>
          <p>{artworkDimensionHeight}</p>
        </ArtworkDimensions>
      </ArtworkDataContainer>
    </main>
  );
};
